document.addEventListener("DOMContentLoaded", function () {
  const blocks = document.querySelectorAll(".rank-math-block");

  blocks.forEach(block => {
    const questions = block.querySelectorAll(".rank-math-question");

    questions.forEach(question => {
      const listItem = question.closest(".rank-math-list-item");
      const answer = question.nextElementSibling;

      question.addEventListener("click", () => {
        const isOpen = listItem.classList.contains("open");

        // Close all other answers in the same block
        block.querySelectorAll(".rank-math-list-item.open").forEach(openItem => {
          openItem.classList.remove("open");
          const openAnswer = openItem.querySelector(".rank-math-answer");
          openAnswer.style.maxHeight = null;
        });

        // Open this answer if it was not already open
        if (!isOpen) {
          listItem.classList.add("open");
          answer.style.maxHeight = answer.scrollHeight + "px";
        }
      });

      // Update max-height on window resize if the item is open
      window.addEventListener("resize", () => {
        if (listItem.classList.contains("open")) {
          answer.style.maxHeight = answer.scrollHeight + "px";
        }
      });
    });
  });
});
